import { render, staticRenderFns } from "./i-video.vue?vue&type=template&id=f7fe6724&scoped=true&"
import script from "./i-video.vue?vue&type=script&lang=js&"
export * from "./i-video.vue?vue&type=script&lang=js&"
import style0 from "./i-video.vue?vue&type=style&index=0&id=f7fe6724&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7fe6724",
  null
  
)

export default component.exports